import { useScrollReveal } from '@/hooks/useScrollReveal';

const trustItems = [
  {
    icon: 'ri-shield-check-line',
    title: 'Vehicle Verification',
    desc: 'Every vehicle on the platform is verified — registration, insurance, and refrigeration unit inspection before listing.',
  },
  {
    icon: 'ri-temp-cold-line',
    title: 'Temperature Logging',
    desc: 'All Freshhlock Transport loads require continuous temperature data logging. Both shipper and transporter receive the complete log after delivery.',
  },
  {
    icon: 'ri-file-shield-line',
    title: 'Insurance & Liability',
    desc: 'Every load is covered by standard cargo insurance. Clear liability terms — no ambiguity about who is responsible if the cold chain breaks.',
  },
  {
    icon: 'ri-user-star-line',
    title: 'Driver Verification',
    desc: 'Drivers are background-verified and rated by previous shippers. A 4.5+ average rating is required to maintain active status on the platform.',
  },
];

export default function TrustCompliance() {
  const { ref, revealed } = useScrollReveal();

  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div ref={ref} className={`container-page scroll-reveal ${revealed ? 'revealed' : ''}`}>
        <div className="text-center mb-14">
          <span className="inline-block text-xs font-semibold text-secondary-600 uppercase tracking-widest mb-4">
            Trust & Safety
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-primary-700 mb-4">
            Trust Built Into Every Load
          </h2>
          <p className="text-foreground-500 max-w-xl mx-auto">
            Cold chain breaks cost money and waste food. That&apos;s why trust isn&apos;t optional — it&apos;s engineered into the platform.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {trustItems.map((item) => (
            <div key={item.title} className="text-center group card-animate">
              <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-2xl bg-secondary-100 text-secondary-600 mb-5 animate-icon-float icon-hover-pop">
                <i className={`${item.icon} text-2xl`}></i>
              </div>
              <h3 className="font-heading font-bold text-primary-700 text-sm mb-2">{item.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}